var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _require = require('../lib/structs'),
    Tx = _require.Tx;

var TxHandler =
/*#__PURE__*/
function () {
  "use strict";

  function TxHandler(tx, rpc) {
    _classCallCheck(this, TxHandler);

    this.tx = tx;
    var self = this;

    this.Pending = function (response) {
      console.log("Pending... tx: " + response.hash + ", " + JSON.stringify(self.tx.actions));
      self.status = "pending";
    };

    this.Success = function (response) {
      console.log("Success... tx, receipt: " + JSON.stringify(response));
      self.status = "success";
    };

    this.Failed = function (res) {
      console.log("Error... tx failed, res: " + JSON.stringify(res) + ", tx: " + JSON.stringify(self.tx));
      self.status = "failed";
    };

    this._rpc = rpc;
    this._hash = "";
    this.status = "idle";
  }

  _createClass(TxHandler, [{
    key: "onPending",
    value: function onPending(c) {
      var self = this;

      this.Pending = function (res) {
        self.status = "pending";

        try {
          var p = c(res);

          if (typeof p === "object" && typeof p.catch === 'function') {
            p.catch(function (e) {
              return console.error("on pending failed. ", e);
            });
          }
        } catch (e) {
          console.error("on pending failed. ", e);
        }
      };

      return this;
    }
  }, {
    key: "onSuccess",
    value: function onSuccess(c) {
      var self = this;

      this.Success = function (res) {
        self.status = "success";

        try {
          var p = c(res);

          if (typeof p === "object" && typeof p.catch === 'function') {
            p.catch(function (e) {
              return console.error("on success failed. ", e);
            });
          }
        } catch (e) {
          console.error("on success failed. ", e);
        }
      };

      return this;
    }
  }, {
    key: "onFailed",
    value: function onFailed(c) {
      var self = this;

      this.Failed = function (res) {
        self.status = "failed";

        try {
          var p = c(res);

          if (typeof p === "object" && typeof p.catch === 'function') {
            p.catch(function (e) {
              return console.log("on failed failed. ", e);
            });
          }
        } catch (e) {
          console.log("on failed failed. ", e);
        }
      };

      return this;
    }
  }, {
    key: "send",
    value: function send() {
      var self = this;

      self._rpc.transaction.sendTx(self.tx).then(function (res) {
        self._hash = res.hash;
        self.Pending(res);
      }).catch(function (e) {
        self.Failed("send tx failed. " + e);
      });

      return self;
    }
  }, {
    key: "listen",
    value: function listen(interval, times) {
      if (!interval || !times) {
        interval = 1000;
        times = 90;
      }

      var self = this;
      var i = 1;
      var id = setInterval(function () {
        //
        if (self.status === "idle") {
          return;
        }

        if (self.status === "success" || self.status === "failed" || i > parseInt(times)) {
          clearInterval(id);

          if (self.status !== "success" && self.status !== "failed" && i > parseInt(times)) {
            self.Failed("Error: tx " + self._hash + " on chain timeout.");
          }

          return;
        }

        i++;

        self._rpc.transaction.getTxReceiptByTxHash(self._hash).then(function (res) {
          if (res.status_code === "SUCCESS" && self.status === "pending") {
            self.Success(res);
          } else if (res.status_code !== undefined && self.status === "pending") {
            self.Failed(res);
          }
        }).catch(function (e) {});
      }, parseInt(interval));
    }
  }], [{
    key: "SimpleTx",
    value: function SimpleTx(contract, abi, args, config) {
      var t = new Tx(config.gasRatio, config.gasLimit, config.delay);
      t.addAction(contract, abi, JSON.stringify(args));
      return t;
    }
  }]);

  return TxHandler;
}();

module.exports = TxHandler;